import React, { useEffect, useState } from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { FollowingNoticesList } from "../../../model/notices/NoticesListModel";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { navigate } from "../../../service/navigation/Navigation";
import { appRoutes } from "../../../routes/routes";
import NoticesDetailContent from "./NoticesDetailContent";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { textCase } from "../../../service/ui/UI";
import { NoticesListContextProvider } from "../../../provider/notices/notices_list/NoticesListContextProvider";
import NoticesDetailActions from "./widget/NoticesDetailActions";
import Scaffold from "../../../widget/layouts/Scaffold";

const NoticesDetailScreen = () => {
  const type: number = ResponsiveDeviceType();

  const [noticeDetail, setNoticeDetail] =
    useState<FollowingNoticesList | null>();

  const setupDetail = () => {
    const sessionNoticeDetailSession: string = SessionStorage.getValue(
      StorageKeys.notices_detail
    );

    if (UtilityHelper.isNotEmpty(sessionNoticeDetailSession)) {
      const sessionNoticeDetail: FollowingNoticesList = JSON.parse(
        sessionNoticeDetailSession
      );
      setNoticeDetail(sessionNoticeDetail);
    } else {
      navigate(appRoutes.routeNameNotices);
    }
  };

  useEffect(() => {
    setupDetail();
  }, []);

  return (
    <NoticesListContextProvider>
      <Scaffold
        appBarTitle={
          noticeDetail != null
            ? textCase(noticeDetail?.title!)
            : AppTranslation.text("notices")
        }
        appBarAction={<NoticesDetailActions />}
      >
        <MainBodyContainer>
          <NoticesDetailContent detail={noticeDetail!} type={type} />
        </MainBodyContainer>
      </Scaffold>
    </NoticesListContextProvider>
  );
};

export default NoticesDetailScreen;
export const routeName: string = "/notices-detail";
